const headers = {
  name: "Inventory",
  pagination: {
    currentPage: 1,
    totalCount: 0,
    totalPages: 0,
  },
  components: [
    {
      type: "search",
      name: "search",
      placeholder: "Search",
      value: "",
    },
  ],
  navigate: {
    tabs: [
      {
        name: "Import/Export",
        path: "/app/importexport",
      },
      {
        name: "Inventory",
        path: "",
      },
    ],
    total: [],
  },
};

export default headers;
